import { Injectable } from "@angular/core";
import { COUNTRIES } from "../_static-data/coutries.library";

export type SimpleCountry = {
  id: string | null;
  name: string;
};
@Injectable({
  providedIn: "root",
})
export class CountriesService {
  constructor() {}

  getCountryById(id: string) {
    const country = COUNTRIES.find((a) => a.ccn3 === id);
    return country;
  }

  getCountryNameById(id: string, lang: "cs" | "en") {
    const country = this.getCountryById(id);
    let countryName = "";
    switch (lang) {
      case "cs":
        countryName = country.translations.ces.official;
        break;
      case "en":
        countryName = country.name.official;
        break;
      default:
        break;
    }
    return countryName;
  }

  getSimpleCountryList(): SimpleCountry[] {
    const countryList: SimpleCountry[] = [];
    COUNTRIES.map((country) => {
      const simpleCountry: SimpleCountry = {
        id: country.ccn3,
        name: country.translations.ces.official,
      };
      countryList.push(simpleCountry);
    });
    countryList.sort((a, b) => a.name.localeCompare(b.name));

    const simpleCzechRepublic = this.getSimpleCountry("203", "cs");

    countryList.unshift(simpleCzechRepublic);

    return countryList;
  }

  getSimpleCountry(id: string, lang: "cs" | "en"): SimpleCountry {
    const country = this.getCountryById(id);
    let countryName = this.getCountryNameById(id, lang);

    const simpleCountry = {
      id: country.ccn3,
      name: countryName,
    };
    return simpleCountry;
  }
}
